import { useAxiosModule } from '@/modules/_shared/axios'
import { AuthenticationRequest, ChangePasswordRequest, Profile } from '@/modules/session/types'
import { HistoryRecord } from '@/modules/_shared/audit-log/types'

const { postToApi, getFromApi, putToApi } = useAxiosModule()

export const authenticationWithEmail = (req: AuthenticationRequest) => {
    return postToApi<string>('authentication/obtain/token', req)
}

export const changePassword = (req: ChangePasswordRequest) =>
    putToApi<string>('me/change-password', req)

export const getProfile = () => getFromApi<Profile>('me')

export const getActivities = () => getFromApi<HistoryRecord[]>('me/activities')
